import { render, staticRenderFns } from "./Doughnut.vue?vue&type=template&id=28884936"
import script from "./Doughnut.vue?vue&type=script&lang=ts"
export * from "./Doughnut.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports